// extracted by mini-css-extract-plugin
var _1 = "Breadcrumb-module__caret--NvLT5";
var _2 = "8px";
var _3 = "Breadcrumb-module__collapsed--qXP9n";
var _4 = "Breadcrumb-module__container--Dqv1F";
var _5 = "Breadcrumb-module__ellipsis--QTuZN";
var _6 = "Breadcrumb-module__highPriority--msRMS";
var _7 = "Breadcrumb-module__maxPriority--xxFGq";
var _8 = "Breadcrumb-module__name--n9PeR";
var _9 = "Breadcrumb-module__truncate--HDYaa";
export { _1 as "caret", _2 as "caretSize", _3 as "collapsed", _4 as "container", _5 as "ellipsis", _6 as "highPriority", _7 as "maxPriority", _8 as "name", _9 as "truncate" }
